module.exports = __webpack_public_path__ + "static/media/8OLA1.6cb80fd6.jpg";